import { Component, OnInit, OnDestroy } from '@angular/core';
import { Notification } from './../../models/notifications/notifications.model';
import { timer } from 'rxjs';
import { ApiService } from './../../shared/services/api.service';
import * as appConfig from './../../app.config';

@Component({
  selector: 'swb-header-notifications',
  templateUrl: './header-notifications.component.html'
})
export class HeaderNotificationsComponent implements OnInit, OnDestroy {
  private _subscription: any;
  public notifications: Notification[] = [];
  public listOpen = false;

  constructor(
    private _apiService: ApiService,
    private _api: ApiService
  ) { }

  ngOnInit() {

    this._reload();
    this._subscription = timer(30000, 30000).subscribe(t => {
      if (!this.listOpen) {
        this._reload();
      }
    });

  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  public routerLink(notification: Notification): Array<any> {
    let link = ['/forms/view', notification.formId ? notification.formId : 0];
    if (notification.type === 'appointment') {
      link = ['/appointments/calendar/' + notification.appointment_calendar_booking.appointment_calendar.id];
    } else if (notification.type === 'booking') {
      link = ['/bookings/booking_overview/' + notification.item_booking.booking_item.booking_offer.id];
    } else if (notification.type?.length > 0) {
      link = ['/' + notification.type + '/formrecords'];
    }
    return link;
  }

  public notificationTitle(notification: Notification): string {
    let title = notification.title ? notification.title : 'kontakt';
    if (notification.type === 'real-estate') {
      title = 'Reality';
    }
    if (notification.type === 'appointment') {
      title = notification.appointment_calendar_booking.appointment_calendar['title_' + appConfig.languages[0]];
    }
    if (notification.type === 'booking') {
      title = notification.item_booking.booking_item['title_' + appConfig.languages[0]];
    }
    return title;
  }

  public toggleList(): void {
    this.listOpen = !this.listOpen;
    if (this.listOpen) {
      this._api.post({}, 'formnotifications/update').subscribe(
        () => { },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this._reload();
    }
  }

  private _reload() {
    this._apiService.get('formnotifications').subscribe(
      (response: any) => {
        this.notifications = { ...response }.data;
      },
      (error) => console.error(error)
    );
  }

}
